<template>
  <div>
    <h2 class="mb-3">Portal Team Members</h2>
    <p>
      Will your team members need access to this account?
      Add team members and assign a role for them here.
    </p>
    <div class="raised">
      <div
        v-for="item in this.contributors"
        :key="item.id"
      >
        <contributor-card
          :contributor="item"
          :contributor_list_size="contributors.length"
          :lastPocUpdate="lastPocUpdate"
          @invite="openInviteModal(item)"
          @edit-role="openInviteModal(item)"
          @refresh="onRefresh"
          @item-deleted="onUpdate"
          @item-updated="onUpdate"
        />
        <hr class="mt-2 mb-1"/>
      </div>
    </div>
    <h2 class="mt-5 mb-3">Add a Portal Team Member</h2>
    <p>
      Portal Team Members are persons you designate to assist with
       borrower portal tasks. Each Portal Team Member you add will
       have access to specific areas of the portal based on the
       role assigned to them:
    </p>
    <roles-table :roles-details="rolesDetails"/>
    <div class="raised pt-3 mb-5 custom-pb">
      <vue-form-generator
        :schema="schema"
        :model="model"
        ref="newPocForm"
      />
      <b-button
        size="md"
        id="btn-save-poc"
        class="btn-anchor raised float-right mr-3"
        @click="savePoc"
      >
        Save
      </b-button>
    </div>
    <team-invite-modal
      ref="invitationModal"
      :roles="roles"
      :lastPocUpdate="this.lastPocUpdate"
      @success="onRefresh"
    />
  </div>
</template>
<script>
import helper from '@/libs/helper';
import helperForm from '@/libs/forms';

import VueFormGenerator from 'vue-form-generator';
import HelpHint from '@/components/utils/hints/HelpHint';
import ContributorCard from '@/components/settings/tabs/team_members/ContributorCard';
import TeamInviteModal from '@/components/settings/tabs/team_members/TeamInviteModal';
import RolesTable from '@/components/settings/tabs/team_members/RolesTable';
import POC_MODEL from '@/components/settings/tabs/team_members/resources/poc_model.json';
import RELATIONSHIP_TYPES from '@/components/settings/tabs/team_members/resources/relationship_types';
import { OWNER } from '@/libs/permissions_list';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheckSquare, faTimesCircle, faEye } from '@fortawesome/free-solid-svg-icons';


library.add([faCheckSquare, faTimesCircle, faEye]);

export default {
  components: {
    'vue-form-generator': VueFormGenerator.component,
    ContributorCard,
    TeamInviteModal,
    HelpHint,
    RolesTable,
  },
  data() {
    return {
      contributors: Array,
      lastPocUpdate: null,
      schema: {
        fields: [],
      },
      model: this.getModel(),
      roles: [],
      rolesDetails: [],
      relationships: RELATIONSHIP_TYPES.relationships,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    changeData() {
      return [this.roles, this.model.relationship];
    },
  },
  methods: {
    openInviteModal(item) {
      this.$refs.invitationModal.show(item);
    },
    onUpdate(response) {
      this.lastPocUpdate = response.data.last_poc_update;
      this.contributors = response.data.poc_list;
    },
    onRefresh() {
      const url = `/users/${this.user.id}/poc/list`;
      this.$reqs.get(url)
        .then((response) => {
          this.onUpdate(response);
        })
        .catch(() => {
        });
    },
    savePoc() {
      if (!this.$refs.newPocForm.validate()) {
        return;
      }

      const data = helper.copy(this.model);
      data.lastPocUpdate = this.lastPocUpdate;
      delete data.agreesToNotifyPoc;

      this.$reqs.post(`/users/${this.user.id}/poc/create`, data)
        .then((response) => {
          this.onUpdate(response);
          this.model = this.getModel();
          this.$swal({
            title: 'Success',
            text: response.data.message,
            type: 'success',
          });
        })
        .catch(() => { this.onRefresh(); });
    },
    getModel() {
      return helper.copy(POC_MODEL);
    },
  },
  mounted() {
    if (!this.$permissions.checkPermissions(OWNER)) {
      return;
    }

    const urlRoles = `/users/${this.user.id}/poc/roles`;
    this.$reqs.get(urlRoles)
      .then((response) => {
        this.roles = response.data;
      })
      .catch(() => {
      });

    const urlRolesDetails = `/users/${this.user.id}/poc/roles_permissions`;
    this.$reqs.get(urlRolesDetails)
      .then((response) => {
        this.rolesDetails = response.data;
      })
      .catch(() => {
      });

    this.onRefresh();
  },
  watch: {
    changeData(newValue) {
      const [newRoles, newRelationship] = newValue;
      const fields = [
        helperForm.simpleInput('text', 'First Name', null, 'firstName', true, 6),
        helperForm.simpleInput('text', 'Last Name', null, 'lastName', true, 6),
        helperForm.email('Email', 'email', null, true, 6),
        helperForm.phone('Cell Phone', 'phone', true, 6),
        helperForm.simpleSelect('Select a role', 'role', true, newRoles, null, 6),
        helperForm.simpleSelect('Select a relationship', 'relationship', true, this.relationships, null, 6),
        helperForm.simpleInput('text', 'Other Relationship', null, 'otherRelationship', true, 6),
        helperForm.checkbox('Invited persons will receive an email from Anchor Loans ' +
          'notifying them that they have been invited to create a Portal Team Member ' +
          'account to perform tasks on your behalf.', 'agreesToNotifyPoc', '', true),
      ];
      if (newRelationship !== 'other') {
        fields.splice(-2, 1);
      }
      this.schema = {
        fields,
      };
    },
  },
};
</script>
<style>
.custom-pb {
  padding-bottom: 4rem !important;
}
.page-column {
  background-color: #eff7ff;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/tabs/team_members/TeamMembersContent.vue